
const CountryList = ({countryData}) => {
    
    let countriesArray = [];

    countriesArray = JSON.parse(countryData);

    return (
      
        <>
        {countriesArray.length > 0 ? (
                countriesArray.map((country, index) => (
                  <span><i className="fa fa-check"></i>{country}</span>
                ))
              ) : (
                null
        )}
        </>

    );
};

export default CountryList;
